"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'file.upload.choose': 'Scegli file...',
    'file.upload.change': 'Cambia file',
    'file.upload.remove': 'Rimuovi file',
    'file.upload.loading': 'Caricamento...',
    'file.upload.drop': 'Trascina file qui',
    'file.upload.download': 'Scarica file',
    'file.upload.choose_multiple': 'Scegli file...',
    'file.upload.change_multiple': 'Cambia file',
    'file.upload.remove_all': 'Rimuovi tutti i file',
    'file.upload.error.size_too_large': 'Il file "{fileName}" è troppo grande. La dimensione massima del file è 2MB.',
    'file.upload.error.size_exceeded_10mb': 'Il file "{fileName}" è troppo grande. La dimensione massima del file è {maxSize}.',
    'file.upload.error.multiple_files_size_exceeded_10mb': 'I seguenti file sono troppo grandi: {fileNames}. La dimensione massima del file è {maxSize}.',
    'file.upload.error.image_too_large': 'L\'immagine "{filename}" ({size}) è troppo grande. Le immagini devono essere sotto {maxSize}.',
    'file.upload.error.unsupported_type': 'Tipo di file non supportato. Si prega di selezionare un formato di file supportato.',
    'file.upload.confirm.add_to_knowledge': 'Il file "{fileName}" ({fileSize}) è troppo grande per la chat. Vorresti aggiungerlo alla base di conoscenza invece?',
    'file.upload.error.total_size_exceeded': 'L\'aggiunta di questo file supererebbe il limite totale di 5MB. Totale attuale: {currentSize}, tentativo di aggiungere: {newSize}.',
    'file.upload.error.processing_failed': 'Errore nell\'elaborazione del file "{fileName}": {error}',
    'file.upload.error.upload_failed': 'Errore nel caricamento dei file: {error}',
    'file.upload.error.submission_failed': 'Errore durante l\'invio della chat: {error}',
};
